import { render, staticRenderFns } from "./AdvancedSearchResults.vue?vue&type=template&id=53c00c2a&scoped=true"
import script from "./AdvancedSearchResults.vue?vue&type=script&lang=ts"
export * from "./AdvancedSearchResults.vue?vue&type=script&lang=ts"
import style0 from "./AdvancedSearchResults.vue?vue&type=style&index=0&id=53c00c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c00c2a",
  null
  
)

export default component.exports